import { render, staticRenderFns } from "./ContactPicker.vue?vue&type=template&id=0066865e&scoped=true"
import script from "./ContactPicker.vue?vue&type=script&lang=js"
export * from "./ContactPicker.vue?vue&type=script&lang=js"
import style0 from "./ContactPicker.vue?vue&type=style&index=0&id=0066865e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0066865e",
  null
  
)

export default component.exports